import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import logo from "./assets/Nexus_logo@3x.png";
import { TEXT } from "./dictionary";
import { internalUsers } from "./constants/userTypes";
import { clearLocalStorage } from "./utils/clearLocalStorage";

function VerifyOtpScreen({ userData, isDarkMode , setIsDarkMode}) {
  const { language } = useLanguage();
  const navigate = useNavigate();
   const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
//   const userData = JSON.parse(localStorage.getItem("userData"));
  const [token, setToken] = useState(localStorage.getItem("token"));
const location = useLocation();
  const parent_id = location.state?.parent_id || null;
const [loading, setLoading] = useState(false);
  const initialValues = {
    otp: "",
  };

  const validate = (values) => {
    const errors = {};
    if (!values.otp) {
      errors.otp = translations.alertMessages.otpRequired?.[language] || "OTP required";
    }
    return errors;
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await fetch(ApiUrl + "/api/user/verifyOtp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: email,
          otp: values.otp,
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        toast.success(TEXT[language].otpVerified || "OTP Verified");

        // const updatedUser = JSON.parse(localStorage.getItem("userData"));
        
        // localStorage.setItem("userData", JSON.stringify(updatedUser));
        setToken(data.token);
            localStorage.setItem("token", data.token);
        localStorage.setItem("userType", data.user.roles[0].name);
        localStorage.setItem("userData", JSON.stringify(data.user));
        localStorage.setItem("eventsFilterData", JSON.stringify([]));
        localStorage.setItem("eventsFilterPostData", JSON.stringify({}));
        localStorage.setItem("clientsFilterData", JSON.stringify([]));
        localStorage.setItem("clientsFilterPostData", JSON.stringify({}));
        localStorage.setItem("appointmentsFilterData", JSON.stringify([]));
        localStorage.setItem("appointmentsFilterPostData", JSON.stringify({}));
        localStorage.setItem("calendarSelectedDate", JSON.stringify(""));

        // navigate("/event-portal");
        
      } else {
        toast.error(data.message);
      }
    
    //   if (data.status === "success") {
    //           toast.success(TEXT[language].otpVerified || "OTP Verified");
      
    //           const updatedUser = JSON.parse(localStorage.getItem("userData"));
              
    //         //   updatedUser["2fa_pop_up"] = true;
    //         //   updatedUser["2fa_phone"] =  values.two_fa_type === "phone" ? "enabled" : "disabled" ;
    //         //   updatedUser["2fa_email"] = values.two_fa_type === "email" ? "enabled" : "disabled" ;
      
    //         //   localStorage.setItem("userData", JSON.stringify(updatedUser));
      
    //           // Redirect after success
    //         //   if (internalUsers.includes(updatedUser?.roles[0]?.name)) {
    //         //     window.location.href = "/event-portal";
    //         //   } else if (
    //         //     updatedUser?.roles[0]?.name === "Manager" ||
    //         //     updatedUser?.roles[0]?.name === "Employee"
    //         //   ) {
    //         //     window.location.href = parent_id
    //         //       ? "/event-portal" + parent_id
    //         //       : "/event-portal";
    //         //   } else {
    //         //     clearLocalStorage();
    //         //     window.location.href = "/login";
    //         //   }
             
    //         } else {
    //           toast.error(data.message);
    //         }
    } catch (err) {
      toast.error(TEXT[language].somethingWrong);
    } finally {
      setSubmitting(false);
    }
  };

useEffect(() => {
    const handleFetchUserData = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/loggeduser", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          if (token) {
            if (data.user?.two_fa_pop_up === "false") {
              navigate("/2fa", { state: { parent_id } });
              return;
            }
            if (internalUsers.includes(data?.user?.roles[0]?.name)) {
              navigate("/event-portal", { replace: true });
            } else if (
              data.user?.roles[0]?.name === "Manager" ||
              data.user?.roles[0]?.name === "Employee"
            ) {
              if (parent_id) {
                // navigate("/client-form?parent_id=" + parent_id, {
                //   replace: true,
                // });
                navigate("/event-portal" + parent_id, {
                  replace: true,
                });
              } else {
                // navigate("/client-dashboard", { replace: true });
                navigate("/event-portal", { replace: true });
              }
            } else {
              toast.error(TEXT[language].invalidUserType);
              clearLocalStorage();
            }
            // const userData = handleFetchUserData();
            // if (userData.user_type === 'admin') {
          }
        } else {
          toast.error(TEXT[language].authFailed);
        }
        // return data;
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(TEXT[language].somethingWrong);
      }
    };
    token && handleFetchUserData();
  }, [token]);

  return (
    <div className="two-fa-screen form-wrapper d-flex justify-content-center align-items-center py-5">
      <main
        className="form-signin p-4 shadow rounded bg-white"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="d-flex justify-content-center mb-4">
          <img className="logo" width="100" src={logo} alt="Logo" />
        </div>

        <h3 className="text-center mb-2">Verify OTP</h3>

        <Formik initialValues={initialValues} validate={validate} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>

              <div className="mb-3">
                <label className="form-label">Enter OTP</label>

                <Field
                  type="text"
                  name="otp"
                  className="form-control"
                  placeholder="Enter OTP"
                />

                <ErrorMessage
                  name="otp"
                  component="div"
                  className="error text-danger mt-1"
                />
              </div>

              <button
                className="w-100 admin-btn btn btn-primary btn-lg"
                type="submit"
                disabled={isSubmitting}
              >
                Verify OTP
              </button>

            </Form>
          )}
        </Formik>
      </main>
    </div>
  );
}

export default VerifyOtpScreen;